import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '../utils/translations';
import { getArrowColor } from '../utils/utils';
import { METRES_TO_KMH } from '../utils/globals';

const WindDirection = props => {
    const { language, data, speed, speedFormat } = props;

    return (
        <div className="wrapper-data-48h mc-widget-wind-direction">
            {/* Label */}
            <div className="wrapper-data-48h__labels mc-widget-wind-direction__labels">
                <div className="mc-widget-TemperaturePerceived__label">
                    <h3>{translate(language, 'municipal48h_dir_vent')}</h3>
                </div>
            </div>
            {/* Data */}
            <div className="wrapper-data-48h__data mc-widget-wind-direction__data">
                {data.map(
                    (data, index) =>
                        data.valor === null ? (
                            <span key={index} />
                        ) : (
                            <span key={index}>
                                <svg
                                    x="0px"
                                    y="0px"
                                    width="20px"
                                    height="20px"
                                    viewBox="-37.794 -27.92 100 100"
                                    enableBackground="new -37.794 -27.92 100 100"
                                    style={{
                                        WebkitTransform: `translate(-1px, 0px) rotate(${Math.round(
                                            data.valor
                                        )}deg)`,
                                        transform: `translate(-1px, 0px) rotate(${Math.round(
                                            data.valor
                                        )}deg)`,
                                        transformOrigin: `10px 10px`,
                                        WebkitTransformOrigin: `10px 10px`,
                                    }}
                                >
                                    <g>
                                        <line
                                            fill="none"
                                            stroke={getArrowColor(
                                                Math.round(
                                                    speed[index].valor *
                                                        METRES_TO_KMH
                                                ),
                                                'color',
                                                speedFormat
                                            )}
                                            strokeWidth="6"
                                            strokeLinecap="round"
                                            strokeLinejoin="bevel"
                                            x1="12.206"
                                            y1="3"
                                            x2="12.206"
                                            y2="41.16"
                                        />
                                        <polygon
                                            fill={getArrowColor(
                                                Math.round(
                                                    speed[index].valor *
                                                        METRES_TO_KMH
                                                ),
                                                'color',
                                                speedFormat
                                            )}
                                            points="0,27.252 12.206,39.466 24.419,27.252 24.419,37.613 12.206,49.822 0,37.613 		"
                                        />
                                    </g>
                                </svg>
                            </span>
                        )
                )}
            </div>
        </div>
    );
};

WindDirection.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            data: PropTypes.string,
            valor: PropTypes.number,
        })
    ),
    language: PropTypes.string,
    speed: PropTypes.arrayOf(
        PropTypes.shape({
            data: PropTypes.string,
            valor: PropTypes.number,
        })
    ),
    speedFormat: PropTypes.string,
};

export default WindDirection;



// WEBPACK FOOTER //
// ./src/partials/WindDirection.js